/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Tournament } from './Tournament';
import {
    TournamentFromJSON,
    TournamentFromJSONTyped,
    TournamentToJSON,
    TournamentToJSONTyped,
} from './Tournament';

/**
 * Result of scheduling or rescheduling a match
 * @export
 * @interface MatchScheduleResponse
 */
export interface MatchScheduleResponse {
    /**
     * 
     * @type {Tournament}
     * @memberof MatchScheduleResponse
     */
    tournament: Tournament;
    /**
     * 
     * @type {string}
     * @memberof MatchScheduleResponse
     */
    message: string;
}

/**
 * Check if a given object implements the MatchScheduleResponse interface.
 */
export function instanceOfMatchScheduleResponse(value: object): value is MatchScheduleResponse {
    if (!('tournament' in value) || value['tournament'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function MatchScheduleResponseFromJSON(json: any): MatchScheduleResponse {
    return MatchScheduleResponseFromJSONTyped(json, false);
}

export function MatchScheduleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchScheduleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tournament': TournamentFromJSON(json['tournament']),
        'message': json['message'],
    };
}

export function MatchScheduleResponseToJSON(json: any): MatchScheduleResponse {
    return MatchScheduleResponseToJSONTyped(json, false);
}

export function MatchScheduleResponseToJSONTyped(value?: MatchScheduleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tournament': TournamentToJSON(value['tournament']),
        'message': value['message'],
    };
}

